<template>
    <a class="dropdown-item" href="#" @click="onClickFunction" :style="{ color: currentValue.color }"
        :title="currentValue.hoverLabel"><i :class="currentValue.icon"></i>&nbsp;&nbsp;{{ currentValue.label }}</a>
    <div v-if="isDivider" class="dropdown-divider"></div>
</template>

<script>
import $ from 'jquery'
import objectDefaultValue from '@/config/object.env'
import i18n from '@/helper/i18n'
export default {
    name: "TheButtonInDropdown",
    props: {
        modelValue: {
            type: [String],
            default: null,
        },
        onClick: {
            type: Function,
            required: true
        },
        submitArgs: {
            type: Array,
            default: () => [], // Default to an empty array if no arguments are passed
        },

        isDivider: {
            type: [Boolean],
            default: false,
        },
    },
    data() {
        return {
            localValue: this.modelValue,
            currentValue: {
                typeButton: ``,
                hoverLabel: ``,
                icon: ``,
                label: ``,
                color: ``
            },
            listAvailabelButton: [
                {
                    typeButton: objectDefaultValue.NAVIGATECODE_VALUE.RESTORE,
                    hoverLabel: this.$t('buttons.restore'),
                    icon: `fas fa-undo`,
                    label: this.$t('buttons.restore'),
                    color: `#28a745`
                },
                {
                    typeButton: objectDefaultValue.NAVIGATECODE_VALUE.DELETE_TEMP,
                    hoverLabel: this.$t('buttons.delete'),
                    icon: `fas fa-trash-restore-alt`,
                    label: this.$t('buttons.delete'),
                    color: `#ffc107`
                },
                {
                    typeButton: objectDefaultValue.NAVIGATECODE_VALUE.DELETE,
                    hoverLabel: this.$t('buttons.deleteReal'),
                    icon: `fas fa-trash-restore-alt`,
                    label: this.$t('buttons.deleteReal'),
                    color: `#dc3545`
                },
                {
                    typeButton: objectDefaultValue.NAVIGATECODE_VALUE.ON_ENABLED,
                    hoverLabel: this.$t('buttons.onEnabled'),
                    icon: `fas fa-toggle-on`,
                    label: this.$t('buttons.onEnabled'),
                    color: `#28a745`
                },
                {
                    typeButton: objectDefaultValue.NAVIGATECODE_VALUE.OFF_ENABLED,
                    hoverLabel: this.$t('buttons.offEnabled'),
                    icon: `fas fa-toggle-off`,
                    label: this.$t('buttons.offEnabled'),
                    color: `#dc3545`
                },

                {
                    typeButton: objectDefaultValue.NAVIGATECODE_VALUE.IMPORT_EXCEL,
                    hoverLabel: this.$t('buttons.importExcel'),
                    icon: `fas fa-file-import`,
                    label: this.$t('buttons.importExcel'),
                    color: `#007bff`
                },
            ],
            isTrueValue: true,
        };
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(newValue) {
                // Tìm trong listAvailabelButton
                const foundButton = this.listAvailabelButton.find(button => button.typeButton === newValue);
                if (foundButton) {
                    this.currentValue = { ...foundButton };
                } else {
                    console.warn(`No button found for modelValue: ${newValue}`);
                }
            }
        }
    },
    methods: {
        onClickFunction() {
            if (typeof this.onClick === 'function') {
                this.onClick(...this.submitArgs);
            } else {
                console.error('onClick is not a function');
            }
        }
    },
    mounted() {
        // Gán giá trị ban đầu từ modelValue nếu có
        if (this.modelValue) {
            const foundButton = this.listAvailabelButton.find(button => button.typeButton === this.modelValue);
            if (foundButton) {
                this.currentValue = { ...foundButton };
            }
        }
    },
};
</script>

<style></style>